import React from "react";

import PropTypes from "prop-types";
import Card from "../Card/Card";
import BodyCopy from "../BodyCopy/BodyCopy";

import "./location-card.scss";

const LocationCard = ({
  buildingIcon,
  flagIconSrc,
  title,
  subTitle,
  cardContent,
  button,
  buttonPlaceholder,
}) => {
  return (
    <Card className="location-card" icon={buildingIcon} iconSize="large">
      <BodyCopy>
        <h4 className="h600 u-margin-bottom-1">{title}</h4>
        <h6 className="h600">{subTitle}</h6>
        <div>
          <div className="flag-wrapper">
            <img className="icon--medium" src={flagIconSrc} alt="flag" />
          </div>
          <div className="card-content">{cardContent}</div>
        </div>
      </BodyCopy>
      <div className="button-wrapper">{button || buttonPlaceholder}</div>
    </Card>
  );
};
LocationCard.propTypes = {
  buildingIcon: PropTypes.func,
  flagIconSrc: PropTypes.string,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  cardContent: PropTypes.string,
  button: PropTypes.node,
  buttonPlaceholder: PropTypes.string,
};
export default LocationCard;
